import { CountryCode } from '../../i18n/countryCodes'

export default function fetchTaxServices(api: GlobalFetch) {
  return async function(lang: CountryCode) {
    const buildUrl = `/api/v2/service/index/lang/${lang}`
    const response = await api.fetch(buildUrl)
    const responseBody: IData = await response.json()

    return (
      responseBody.items &&
      responseBody.items.map(i => ({
        ...i,
        hidden: Boolean(Number(i.hidden)),
        first_tax: Number(i.first_tax),
        second_tax: Number(i.second_tax),
        deleted: Boolean(Number(i.deleted)),
        max_amount: Boolean(Number(i.max_amount)),
        max_amount_value: Boolean(Number(i.max_amount))
          ? Number(i.max_amount)
          : 2,
        obligatory: Boolean(Number(i.obligatory)),
        free: Boolean(Number(i.free)),
        all_rooms:
          !i.rooms ||
          (i.rooms && (i.rooms.includes('0') || i.rooms.length === 0)),
        rooms: i.rooms,
        unit_type:
          !i.unit_type || i.unit_type === '0' ? '0' : Number(i.unit_type),
      }))
    )
  }
}

export interface IData {
  messages: string[]
  items: IServices[]
}

export interface IServices {
  service_name: string
  price: string
  default: string
  first_tax: string
  second_tax: string
  hidden: string
  id: string
  rooms: string[]
  all_rooms: string
  max_amount: string
  max_amount_value: string
  obligatory: string
  free: string
  unit_type: string
  deleted: string
}
